<template>
  <li class="row-content">
    <div class="d-flex align-items-center pr-1 t-sm">
      <span class="t-600">{{'Location' | pluralize(renderedCountries.length)}}:</span>
      <span v-for="(country, index) in renderedCountries.slice(0, countriesToShow)" :key="index">
        <flag :title="renderCountryFlagTooltip(country)"
          v-if="country.alpha_2"
          :iso="country.alpha_2 | lowercase"
          :squared="false"
          class="bd-radius ml-1" />
      </span>
      <span v-if="renderedCountries.length > countriesToShow" class="ml-2 t-400">+{{renderedCountries.length - countriesToShow}}</span>
    </div>
  </li>
</template>

<script>
export default {
  name: 'searchResultPartialLocations',
  data () {
    return {
      countriesToShow: 3
    }
  },
  props: {
    locations: {
      type: Array,
      default: () => ([])
    }
  },
  computed: {
    renderedCountries () {
      const arr = []
      this.locations.forEach(location => {
        if (!arr.find(l => l.alpha_2 === location.country.alpha_2)) {
          arr.push(location.country)
        }
      })
      return arr
    }
  }
}
</script>
